import styled from 'styled-components';

export const StyledMain = styled.main`
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  min-height: 100vh;
  flex-direction: column;
`;